import { Vendor } from "../../CRUDs/entities/Vendor"


export default{
    init(){
        //this.vendorUploadFiles();
        this.vendorFilesMenu();
        this.menuActions();
    },
    uploadListener(vendorId){
        if (vendorId) {
            const vendor = new Vendor(vendorId);
            vendor.scopeOpenDropZoneListener();
        }
    },

    vendorUploadFiles(){
        $('body')
            .off('click','#vendors_attachments .add-vendor-attachemnt')
            .on('click','#vendors_attachments .add-vendor-attachemnt', (e) => {
                const vendorId = $(e.target).data('id');
                console.log('click vendorUploadFiles', vendorId);
                this.uploadListener(vendorId);
            })
    },

    vendorFilesMenu(){
        $('body').off('click', '#vendors_attachments .file-menu')
        .on('click', '#vendors_attachments .file-menu', (e) => {
            const vendor_id = $(e.target).data('id');
            const file_id = $(e.target).data('file_id');
            console.log('jearnginergu', vendor_id, file_id);
            let position = this.calculateElemPosition(e.target, $('.file-menu-modal'), 10, 0);
            $('.file-menu-modal').show();
            $('.file-menu-modal').css({left: position[0], top: position[1]});
            $('.file-menu-modal').find('.download-btn').attr('href', $(e.target).data('d_link'));
            $('.file-menu-modal').find('.delete-file-btn').data('entity', 'vendor');
            $('.file-menu-modal').find('.delete-file-btn').data('file-id', file_id);
            $('.file-menu-modal').find('.delete-file-btn').data('entity-id', vendor_id);
            $('.file-menu-modal').find('.preview-file-btn').data('src', $(e.target).parents('.file').find('img').attr('src'));
        })
    },

    /**
     *
     * @param {JQuery} elem
     * @param {JQuery} modal
     * @param {int} paddingRight
     * @param {int} paddingTop
     * @return Array [posX, posY]
     */
    calculateElemPosition(elem, modal, paddingRight, paddingTop){
        let posX = $(elem).offset().left;
        let modal_widht = $(modal).width();
        let posY = $(elem).offset().top - parseInt(paddingTop);
        posX = posX - modal_widht - parseInt(paddingRight);
        return [
            posX,
            posY
        ]
    },

    menuActions(){
        $('.file-menu-modal .close-element').click(function() {
            $('.file-menu-modal').hide();
        });
    }
}
